import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { GET_DASHBOARD_USER, GET_USER_NAMES } from "../endpoint";
import apiCall from "../utils/apiCall";
import { Search } from "@mui/icons-material";
import coins_svg from "../assets/coins.svg";
import selectuser_svg from "../assets/selectuser.svg";
import website_svg from "../assets/website.svg";
import token_svg from "../assets/token.svg";
import UserHeaderComponent from "./UserHeaderComponent";
import BarChart from "./BarGraph";
import DoughnutChart from "./DoughnutChart";
import RequestsHeader from "./RequestHeader";
import RequestsItem from "./RequestItem";
import LoadingDashboard from "./LoadingDashboard";
import { useAppDispatch } from "../hooks/reduxhook";
import { addError } from "../redux/slices/errorSlice";
interface i_user {
  // user_email: string;
  // user_name: string;
  // user_email: string;
  label: string;
  value: string;
}

const Users: React.FunctionComponent = () => {
  const [users, setUsers] = React.useState<i_user[]>([]);
  const [selectUser, setSelectUser] = React.useState<i_user>();
  const [userData, setUserData] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    const fetUserList = () => {
      apiCall("GET", GET_USER_NAMES)
        .then((res) => {
          setUsers(
            res.result.map((r: any) => ({
              label: r.user_name,
              value: r.user_id,
            }))
          );
        })
        .catch((err) => {
          dispatch(addError("Failed to load the users.Please try again."));
        });
    };
    fetUserList();
  }, []);

  const searchUser = () => {
    setLoading(true);
    apiCall("POST", GET_DASHBOARD_USER, {
      user_email: selectUser?.value,
    })
      .then((res: any) => {
        let total_cost: any = 0;
        let total_token: any = 0;
        const models: any = {
          "gpt-35-turbo": 0,
          "gpt-35-turbo-16k": 0,
          "gpt-4-32k": 0,
          "gpt-4-8k": 0,
        };
        const chat_types: any = {
          default: 0,
          rag: 0,
        };

        const model_with_type: any = {
          "gpt-35-turbo_default": 0,
          "gpt-35-turbo_rag": 0,
          "gpt-35-turbo-16k_default": 0,
          "gpt-35-turbo-16k_rag": 0,
          "gpt-4-32k_default": 0,
          "gpt-4-32k_rag": 0,
          "gpt-4-8k_default": 0,
          "gpt-4-8k_rag": 0,
        };

        res.result.forEach((f: any) => {
          total_cost = total_cost + f.cost;
          total_token = total_token + f.total_token;
          models[`${f.model}`] += 1;
          chat_types[`${f.chat_type}`] += 1;
          model_with_type[`${f.model}_${f.chat_type}`] += 1;
        });
        setUserData({
          total_cost: total_cost,
          models,
          chat_types,
          total_calls: res.result.length,
          total_token,
          model_with_type,
          chats: res.result,
        });
      })
      .catch((err) => {
        dispatch(addError("Failed to load the users.Please try again."));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Grid container my={2} alignItems="center">
      <Autocomplete
        options={users}
        value={selectUser}
        sx={{ flex: 1 }}
        onChange={(e, d: any) => setSelectUser(d)}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => <TextField {...params} label="Search User" />}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (selectUser) searchUser();
          }
        }}
      />
      <Button>
        <Search onClick={searchUser} />
      </Button>
      <Grid
        container
        sx={{
          my: 2,
        }}
        direction="column"
      >
        {loading ? (
          <LoadingDashboard />
        ) : userData ? (
          <>
            <Grid container my={2} alignItems="center">
              <UserHeaderComponent
                title="Total Cost:"
                value={userData?.total_cost}
                icon={coins_svg}
              />
              <UserHeaderComponent
                title="Total Events:"
                value={userData?.total_calls}
                icon={website_svg}
              />
              <UserHeaderComponent
                title="Total tokens:"
                value={userData?.total_token}
                icon={token_svg}
              />
            </Grid>
            <Divider
              sx={{
                mb: 2,
              }}
            />
            <Grid container>
              <Grid
                container
                xs={6}
                sx={{
                  borderRight: "1px solid rgba(0,0,0,.1)",
                  // p: 2,
                }}
                direction="column"
                alignItems="center"
              >
                <Grid
                  sx={{
                    height: "250px",
                    width: "90%",
                  }}
                >
                  <BarChart
                    labels={[
                      "gpt-35-turbo",
                      "gpt-35-turbo-16k",
                      "gpt-4-32k",
                      "gpt-4-8k",
                    ]}
                    dataset1={[
                      userData?.model_with_type["gpt-35-turbo_default"],
                      userData?.model_with_type["gpt-35-turbo_rag"],
                      userData?.model_with_type["gpt-35-turbo-16k_default"],
                      userData?.model_with_type["gpt-35-turbo-16k_rag"],
                    ]}
                    label1="Default"
                    dataset2={[
                      userData?.model_with_type["gpt-4-32k_default"],
                      userData?.model_with_type["gpt-4-32k_rag"],
                      userData?.model_with_type["gpt-4-8k_default"],
                      userData?.model_with_type["gpt-4-8k_rag"],
                    ]}
                    label2="RAG"
                  />
                  <Divider
                    sx={{
                      mt: 2,
                    }}
                  >
                    Chat types for each model
                  </Divider>
                </Grid>
              </Grid>
              <Grid container xs={6} direction="column" alignItems="center">
                <Grid
                  sx={{
                    height: "250px",
                    width: "90%",
                  }}
                >
                  <DoughnutChart
                    labels={Object.keys(userData?.models)}
                    dataset={Object.values(userData?.models)}
                  />
                  <Divider
                    sx={{
                      mt: 2,
                    }}
                  >
                    Model usage
                  </Divider>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              sx={{
                my: 4,
              }}
            />
            <RequestsHeader />
            {userData?.chats.map((item: any) => (
              <RequestsItem item={item} key={item.chat_id} />
            ))}
          </>
        ) : (
          <Grid
            container
            justifyContent="center"
            direction="column"
            alignItems="center"
          >
            <img
              src={selectuser_svg}
              alt="select user"
              className="selectuser"
            />
            <Typography
              sx={{
                mt: 2,
              }}
            >
              please select a user...
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Users;
